import React, {useCallback, useContext, useEffect, useState} from 'react';

import {NavLink, useParams} from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  Stack,
  Typography,
} from '@mui/material';

import { UserRound, Inbox, ClipboardList, Star } from 'lucide-react';

import Axios from '../../../Assets/Axios/Axios';

import {COLORS} from '../../../Constant/COLORS';

import Header from '../../../Components/Header';
import Footer from '../../../Components/Footer';
import { PageFade } from '../../../Components/Motion';

import {FindUser} from '../../../Server/Query';
import {useIsMobile} from '../../../Hooks/useIsMobile';
import MobileNavigationLayout from './MobileNavigationLayout';
import AuthContext from '../../../Context/AuthContext';

const navLinks = [
  {text: 'My Details', to: 'my-details', icon: UserRound},
  {text: 'Job Requests', to: 'job-requests', icon: Inbox},
  {text: 'Job Information', to: 'job-information', icon: ClipboardList},
  {text: 'Review Manage', to: 'review-manage', icon: Star},
];

const Layout = ({children}) => {
  const [fullNameOfUser, setFullNameOfUser] = useState('');

  const {user} = useContext(AuthContext);
  const {userID} = useParams();
  const resolvedUserId = user?.userID ?? userID;

  const isMobile = useIsMobile();

  const fetchAndSetFullName = useCallback(async () => {
    if (!resolvedUserId) return undefined;
    const resData = await Axios(FindUser({userID: resolvedUserId}));
    if (resData?.errors) return undefined;
    const eventBooker = resData.data?.EventBooker;
    setFullNameOfUser(
      [eventBooker?.first_name, eventBooker?.last_name].filter(Boolean).join(' ')
    );
  }, [resolvedUserId]);

  useEffect(() => {
    fetchAndSetFullName();
  }, [fetchAndSetFullName]);

  return (
    // <>
    //   <Header isUserPage />
    //   <Divider sx={{ borderColor: COLORS.grey5 }} />

    //   <Box ml='10%' mb='10vh' maxWidth={fullWidth ? '85%' : '80%'}>
    //     <Typography fontWeight={600} variant='h6' my={4}>
    //       {fullNameOfUser}
    //     </Typography>

    //     <Stack direction='row' gap={6}>
    //       <List sx={{ ml: -2, whiteSpace: 'nowrap' }} disablePadding>
    //         {navLinks.map(({ text, to }) => (
    //           <ListItem disableGutters disablePadding sx={{ mb: 1 }} key='text'>
    //             <ListItemButton
    //               component={NavLink}
    //               to={`../${to}`}
    //               style={({ isActive }) =>
    //                 isActive
    //                   ? { backgroundColor: COLORS.white3, borderRadius: 4 }
    //                   : undefined
    //               }
    //             >
    //               <Typography
    //                 variant='body1'
    //                 fontWeight={600}
    //                 color={COLORS.blue}
    //                 sx={{ pointerEvents: 'none' }}
    //               >
    //                 {text}
    //               </Typography>
    //             </ListItemButton>
    //           </ListItem>
    //         ))}
    //       </List>
    //       {children}
    //     </Stack>
    //   </Box>
    //   <Footer />
    // </>
    <>
      <Header isUserPage/>

      {isMobile && <MobileNavigationLayout/>}

      <Divider sx={{borderColor: COLORS.hairline}}/>

      <Box px={{xs: 2, md: '10%'}} mt={{xs: 2.5, md: 5}} mb='10vh'>
        {!isMobile && (
          <Typography
            textAlign={{xs: 'center', md: 'unset'}}
            variant='h4'
            color={COLORS.teal}
            my={4}
          >
            {fullNameOfUser}
          </Typography>
        )}
        <Stack mt={{md: 3}} direction='row' gap={8}>
          {!isMobile && (
            <List
              disablePadding
              sx={{
                whiteSpace: 'nowrap',
                p: 1.5,
                border: `1px solid ${COLORS.hairline}`,
                borderRadius: 3,
                bgcolor: COLORS.surface,
                height: 'fit-content',
                minWidth: 210,
              }}
            >
              {navLinks.map(({text, to, icon: Icon}) => (
                <ListItem
                  key={text}
                  disableGutters
                  disablePadding
                  sx={{mb: 0.5}}
                >
                  <ListItemButton
                    component={NavLink}
                    to={`../${to}`}
                    sx={{
                      borderRadius: 2,
                      gap: 1.25,
                      transition: 'background-color .18s ease, padding-left .18s ease',
                      '&:hover': { backgroundColor: COLORS.surfaceAlt, pl: 2.25 },
                    }}
                    style={({isActive}) =>
                      isActive
                        ? {backgroundColor: COLORS.tealSoft, color: COLORS.teal}
                        : {color: COLORS.inkSoft}
                    }
                  >
                    <Icon size={18} strokeWidth={1.8} style={{pointerEvents: 'none'}} />
                    <Typography
                      variant='body1'
                      fontWeight={600}
                      sx={{pointerEvents: 'none', color: 'inherit'}}
                    >
                      {text}
                    </Typography>
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          )}
          <Box flexGrow={1} minWidth={0}>
            <PageFade>{children}</PageFade>
          </Box>
        </Stack>
      </Box>
      <Footer/>
    </>
  );
};

Layout.propTypes = {
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
};

export default Layout;
